import genericApi from './genericApi';

import ForwarderModel from '../models/ForwarderAwb';
import ApiResponse from '../models/ApiResponse';
import GhaManualEntryDriverInfo from '../models/GhaManualEntryDriverInfo';
import StationsModel from '../models/Stations';
import ForwarderNewModel from '../models/ForwarderNew';
import ForwarderLocationModel from '../models/ForwarderLocation';

const forwarderReqHandler = {

  getForwarders: (opts: {all?: boolean, type?: string}): Promise<ApiResponse<Array<ForwarderModel>>> => {
    let url = 'forwarder?';
    if (opts.all) 
      url += 'all=true&';
    if (opts.type)
      url += `forwarder_type=${opts.type}`;
    return genericApi.get(url);
  },

  forwarderImpersonate: (fwdId: number, driverInfo: GhaManualEntryDriverInfo, dockId: number | null, orderId?: any, orderNumber?: number): Promise<ApiResponse<boolean>> => {
    driverInfo = {...driverInfo};
    if(driverInfo.arrivalTime.length === 5) {
      driverInfo.arrivalTime = driverInfo.arrivalTime.substr(0,2) + driverInfo.arrivalTime.substr(3, 2);
    }
    return genericApi.post(`impersonate/fwd/${fwdId}`, { driverInfo, dockId, orderId, poNumber: orderNumber });
  },

  createForwarder: (fwd_name: string, type: string, location: string | null, added: string | null, is_active: boolean | null, ghaId: number | null) : Promise<ApiResponse<ForwarderLocationModel>> => {
    let name: string = fwd_name.toUpperCase().trim();
    return genericApi.put('forwarder', {name, type, location, added, is_active, ghaId});
  }, 

  getStations: (opts: {all?: boolean}): Promise<ApiResponse<Array<StationsModel>>> => {  
    let url = 'station?';
    if(opts.all)  
      url += 'all=true'; 
    return genericApi.get(url);
  }, 

  getStationForwarders: (opts: {code?: string, type?: string, gha: number | undefined }): Promise<ApiResponse<Array<ForwarderNewModel>>> => {
    let url = 'station/forwarder?';
    if (opts.code) 
      url += `code=${opts.code}&`;
    if (opts.type)
      url += `type=${opts.type}&`;
    if (opts.gha)
      url += `gha=${opts.gha}`;
    return genericApi.get(url);
  },

  checkForwarderExists: (opts: {forwarder_name?: string, iata_code?: string, is_active?: boolean, ghaId?: number, nullCheck?: boolean}): Promise<ApiResponse<Array<ForwarderNewModel>>> => {   
    let url = 'check_fwd_exists?';
    if(opts.forwarder_name)
      url += `forwarder_name=${encodeURIComponent(opts.forwarder_name)}&`;
    if(opts.iata_code)
      url += `iata_code=${opts.iata_code}&`;
    if(opts.is_active)
      url += `is_active=${opts.is_active}&`;
    if(opts.ghaId)
      url += `ghaId=${opts.ghaId}&`;
    if(opts.nullCheck)
      url += `nullCheck=${opts.nullCheck}`;
    return genericApi.get(url);
  },

  addForwarderLocation: (fwdId: number, location: string, ghaId: number) : Promise<ApiResponse<ForwarderLocationModel>> => {
    return genericApi.put('forwarder_location', {fwdId, location, ghaId});
  },
  
  getForwaderByRelevance: (opts: {name?: string, iata_code?: string, ghaId?: number}): Promise<ApiResponse<Array<ForwarderNewModel>>> => {
    let url = 'forwarder_byrelevance?';
    if(opts.name)
      url += `name=${encodeURIComponent(opts.name)}&`;
    if(opts.iata_code)
      url += `iata_code=${opts.iata_code}&`;
    if(opts.ghaId)
      url += `ghaId=${opts.ghaId}`;
    return genericApi.get(url);
  },

  getForwarderByName: (opts: {forwarder_name: string}): Promise<ApiResponse<Array<ForwarderNewModel>>> => {
    let url = 'forwarder_byname?';   
    if(opts.forwarder_name)
      url += `forwarder_name=${encodeURIComponent(opts.forwarder_name)}`;
    return genericApi.get(url);
  },

  getForwarderLocation: (opts: {fwdId: number}): Promise<ApiResponse<Array<ForwarderLocationModel>>> => {
    let url = 'forwarder_location?';    
    if(opts.fwdId)
      url += `id=${opts.fwdId}`;
    return genericApi.get(url);
  },

  updateForwarderStatus: (fwdId: number, location: string, is_active: boolean, ghaId: number): Promise<ApiResponse<ForwarderLocationModel>> => {    
    return genericApi.put('forwarder/status', {fwdId, location, is_active, ghaId});
  }

};

export default forwarderReqHandler;